import { observer } from 'mobx-react-lite'

import { useApi } from '../../../hooks/storeHook'

import { MarketplacePricesSettings } from '../PricesSettings'
import { YandexMarketPriceTypesMatching } from './YandexMarketPriceTypesMatching'
import { YandexMarketUnifiedPricesToggle } from './YandexMarketUnifiedPricesToggle'

import { YmAccountProps } from '../../../types/accountProps'

export const YandexMarketPricesSettings =
  observer(
    (props: YmAccountProps) => {
      const {
        userSync: {setYandexMarketPriceTypes, updatePricesYandexMarket},
        prices: {enablePriceSyncYandexMarket}
      } = useApi()

      return (
        <MarketplacePricesSettings
          {...props}
          onAddDefaultPrices={enablePriceSyncYandexMarket}
          onForceUpdatePrices={updatePricesYandexMarket}
          setPriceTypes={setYandexMarketPriceTypes}
          TopComponent={YandexMarketUnifiedPricesToggle}
          PriceTypesMatchingComponent={YandexMarketPriceTypesMatching}
        />
      )
    })